import "./index.css";

import Orb from "@/components/blocks/Backgrounds/Orb/Orb";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

// TODO: Use this later for styling
const theme = {
	colors: {
		background: "#0A0A12",
		accent: "#F6416C",
		highlight: "#FFF6B7",
	},
};

export function App() {
	return (
		<div className="w-full" style={{ height: 600 }}>
			<div className="relative h-full w-full">
				{/* Orb background */}
				<div className="absolute inset-0 pointer-events-none">
					<Orb
						hoverIntensity={0}
						rotateOnHover={false}
						hue={270}
						forceHoverState={false}
					/>
				</div>

				{/* Foreground content */}
				<div className="relative z-10 flex h-full w-full items-center justify-center p-8 text-center">
					<div className="flex flex-col items-center gap-4">
						{/* Badge above tagline */}
						<Badge className="uppercase tracking-wide">
							coming september 2025
						</Badge>

						<h1 className="text-4xl font-bold">connect with influence</h1>

						{/* Discord button below tagline */}
						<div className="mt-2">
							<Button size="lg" asChild>
								<a
									href="https://discord.com/invite/wwJmpYJPaB"
									target="_blank"
									rel="noopener noreferrer"
								>
									Join our Discord
								</a>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
